module.exports = __webpack_public_path__ + "static/img/frack1.f647f13d.png";